<template>
<div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <div v-else>
        <b-navbar toggleable="lg" type="dark" variant="light">
            <b-navbar-brand href="#" class="text-dark">
                <strong>PRI Calculation Overview</strong>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto"></b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <b-row class="mt-1">
            <b-col cols="3">
                <DetailsComponent :searchData="searchData" v-if="!isLoading" />
            </b-col>
            <b-col cols="9">
                <b-tabs>
                    <b-tab title="Calculation">
                        <CalculationComponent :isLoading="isLoading" />
                    </b-tab>
                    <!-- <b-tab title="Country" v-if="priSearchData.showNegativeMedia">
                        <ul>
                            <li>The country Switzerland is not listed on the CPI active sanctions list</li>
                            <li>The country Switzerland has CPI rating of <b-badge>30</b-badge></li>
                        </ul>
                       
                    </b-tab> -->
                    <!-- <b-tab title="Industry" v-if="priSearchData.showNegativeMedia">
                        
                    </b-tab> -->
                    <b-tab title="Negative Media" v-if="priSearchData.showNegativeMedia">
                        <MediaResultsDataComponent v-if="!isLoading" :negativeMedia="negativeMediaArray" />
                    </b-tab>

                    <!-- <b-tab :title="'S&E Alerts('+sanctions.length+')'" v-if="priSearchData.showSanctions">
                        <SanctionsEnforcementsAlertsComponent :sanctions="sanctions" :eventCategories="priSearchData.sanctions.eventSubCategoryCodeSelected" :v-text="[]" v-if="!isLoading" />
                    </b-tab> -->
                    <b-tab title="Open Corporate Data" class="p-3" v-if="priSearchData.showOpenCorporate">
                        <OpenCorporateDataComponent v-if="!isLoading" :openCorporateData="openCorporateData" />
                    </b-tab>
                    <b-tab title="Future Risks" v-if="priSearchData.showFutureRisks">
                        <FutureRisksComponent :futureRisks="futureRisksArray" v-if="!isLoading" />
                    </b-tab>
                    <b-tab title="Public Company" v-if="priSearchData.showPublicListing" style="height:calc(100vh - 200px);overflow-y:auto;">
                        <b-row>
                            <b-col cols="12" class="mb-3">
                                <b-card>
                                    <b-card-text>Subject Name: {{publicListedCompanies.searchData.subjectFullName || ''}}</b-card-text>
                                    <b-card-text>Subject Name Without Stop words: {{publicListedCompanies.searchData.nameWithStopWords || ''}}</b-card-text>
                                    <b-card-text>Partial Name: {{publicListedCompanies.searchData.partialName || ''}}</b-card-text>
                                </b-card>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="mb-3" cols="4" v-for="(company,index) in publicListedCompanies.companies" :key="index">
                                <b-card>
                                    <b-card-text>Listing Name: {{company.listingData.name || 'N/A'}}</b-card-text>
                                    <b-card-text>Local Name: {{company.listingData.local_name || 'N/A'}}</b-card-text>
                                    <b-card-text>Country: {{company.listingData.country || 'N/A'}}</b-card-text>
                                    <b-card-text>Stock Exchange: {{company.listingData.stock_exchange || 'N/A'}}</b-card-text>
                                    <b-card-text>Stock Exchange Code: {{company.listingData.stock_exchange_code || 'N/A'}}</b-card-text>
                                    <b-card-text>
                                        Proccess:
                                        <b-badge variant="warning">{{company.fuzzyWuzzy.process || 0}}</b-badge>
                                    </b-card-text>
                                    <b-card-text>
                                        Simple Ratio:
                                        <b-badge variant="success">{{company.fuzzyWuzzy.simpleRatio || 0}}</b-badge>
                                    </b-card-text>
                                    <b-card-text>
                                        Partial Ratio:
                                        <b-badge variant="success">{{company.fuzzyWuzzy.partialRatio || 0}}</b-badge>
                                    </b-card-text>
                                    <b-card-text>
                                        Token Set Ration:
                                        <b-badge variant="success">{{company.fuzzyWuzzy.tokenSetRatio || 0}}</b-badge>
                                    </b-card-text>
                                    <b-card-text>
                                        Token Sort Ratio:
                                        <b-badge variant="success">{{company.fuzzyWuzzy.tokenSortRatio || 0}}</b-badge>
                                    </b-card-text>
                                    <b-card-text>
                                        Similar Text:
                                        <b-badge variant="success">{{company.similarText || 0}}</b-badge>
                                    </b-card-text>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <!-- <b-tab title="Configuration" v-if="priSearchData">
                        <ConfigurationComponent :form="priSearchData" />
                    </b-tab> -->
                    <!-- <b-tab title="Reports" class="p-3">
                        <b-tabs vertical pills>
                            <b-tab title="S&E">

                            </b-tab>
                            <b-tab title="Negative Media">
                                <b-tabs>
                                    <b-tab title="Anti Bribery" class="p-3">
                                      <b-card title="Findings" class="text-left">
                                        <h3>Positive Matches</h3>
                                        <b-card-text>
                                          Out of 10 articles we found 3 positive matches. 
                                          From the 3 positive matches we were able to deduce:
                                          <h5>Site Type Matches</h5>
                                          <ul>
                                            <li>1 match is from a global site</li>
                                            <li>2 match from a regional site</li>
                                            <li>1 from a local site</li>
                                          </ul>
                                          <h5>Site Type Matches</h5>
                                          <ul>
                                            <li>2 artciles have matched all keywords</li>
                                            <li>2 artclies have 10 or more keyword match</li>
                                            
                                          </ul>
                                          <h5>NLP</h5>
                                          <ul>
                                            <li>1 article had a positive</li>
                                           
                                          </ul>
                                          <h5>Age</h5>
                                          <ul>
                                            <li>2 articles had no dates</li>
                                            <li>Oldest article is 425 days</li>
                                          </ul>
                                         
                                        </b-card-text>
                                      </b-card>
                                     
                                    </b-tab>
                                </b-tabs>
                            </b-tab>
                            <b-tab title="Future Risks">

                            </b-tab>
                            <b-tab title="Public Listed Companies">
                                we found subject name as listed company 
                                We found 3 other similar name companies as publicly listed company
                                From the 3 one is of the same country and listed on the stock Exchange
                                one is listed on DOW Jones
                                One is liste on DAX
                            </b-tab>
                             <b-tab title="Company Information">
                               <b-row>
                                 <b-col cols="6">
                                   <ul>
                                     <li>We found a total of 72 companies with a similar name match in the same jursidiction.</li>
                                     <li>We found a total of 32 companies with a similar name match in the same Globally.</li>

                                     <li>We found a total of 604 companies with a partial name in the same jursidiction.</li>
                                     <li>We found a total of 604 companies with a partial name in the same Globally.</li>
                                     <li>The name of the company is <b-badge variant="success">very rare</b-badge></li>
                                   </ul>
                                   
                                 </b-col>
                               </b-row>
                                
                            </b-tab>


                        </b-tabs>
                    </b-tab> -->
                    <!-- <b-tab title="Charts">
                        <b-card header="Search Control Group Chart" class="mb-2" style="height: calc(490px - 65px); overflow-y:auto;">
                            <b-card-body style="height:250px;" class="p-0">
                                <ChartComponent :id="'oveiver'" :type="'radar'" :labels="radarChartLabels.controlGroupSearch" :dataset="radarChartDatasets" :options="radarChartOptions" />
                            </b-card-body>
                        </b-card>
                    </b-tab> -->
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import AppLoader from "../components/Loader/Loader";
import ConfigurationComponent from "../components/Pri/priSearchComponent/configurationComponent.vue";
import DetailsComponent from "../components/Pri/priSearchComponent/detailsComponent.vue";
import CalculationComponent from "../components/Pri/priSearchComponent/calculationComponent.vue";
import MediaResultsDataComponent from "../components/Pri/priSearchComponent/mediaResultsDataComponent.vue";
import SanctionsEnforcementsAlertsComponent from "../components/Pri/priSearchComponent/sanctionsEnforcementsAlertsComponent.vue";
import OpenCorporateDataComponent from "../components/Pri/priSearchComponent/openCorporateDataComponent.vue";
import FutureRisksComponent from "../components/Pri/priSearchComponent/futureRisksComponent.vue";
import ChartComponent from "../components/charts/chart.vue";
import {
    HTTP
} from "../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
    name: "PriSearchControlGroupContainer",
    components: {
        AppLoader,
        ConfigurationComponent,
        DetailsComponent,
        CalculationComponent,
        MediaResultsDataComponent,
        SanctionsEnforcementsAlertsComponent,
        OpenCorporateDataComponent,
        FutureRisksComponent,
        ChartComponent
    },
    data() {
        return {
            radarChartLabels: {
                controlGroupSearch: [
                    "Running",
                    "Swimming",
                    "Eating",
                    "Cycling",
                    "Cycling",
                    "Egg"
                ]
            },
            radarChartDatasets: [{
                    label: "Number of Orders",
                    data: [55, 45, 32, 22, 29, 60],
                    borderWidth: 3,
                    borderColor: ["#47b784"],
                    backgroundColor: ["rgba(71, 183,132,.5)", "rgba(71, 183,132,.5)"]
                },
                {
                    label: "Non-Conformity",
                    data: [27, 14, 75, 98, 13, 63],
                    borderWidth: 3,
                    borderColor: ["#36495d", "#47b784"],
                    backgroundColor: [
                        "rgba(54,73,93,.5)", // Blue
                        "rgba(71, 183,132,.5)"
                    ]
                }
            ],
            radarChartOptions: {
                scale: {
                    angleLines: {
                        display: false
                    },
                    ticks: {
                        suggestedMin: 50,
                        suggestedMax: 100
                    }
                }
            },
            searchData: null,
            isLoading: true,

            negativeMediaArray: [],
            futureRisksArray: [],
            priSearchData: undefined,

            sanctions: [],
            companyTotals: null,
            openCorporateCompanyData: null,
            openCorporateGlobalExactMatchTotals: null,
            openCorporateCountryExactMatchTotals: null,
            openCorporateGlobalPartialMatchTotals: null,
            openCorporateCountryPartialMatchTotals: null,
            openCorporateData: null,
            publicListedCompanies: null
        };
    },
    computed: {},
    mounted() {
        this.isLoading = true;
        this.getSearchData(this.$route.params.searchId);
    },
    methods: {
        checkValue() {
            let metaData = JSON.parse(this.searchData.meta_data);
            // // console.log(metaData);
            let check = metaData.map(value => {
                value.customAtValue.map(element => {
                    //   // console.log(element);
                });
            });
        },
        age(value) {
            moment.locale("en");

            return moment.utc(value).fromNow();
        },
        async getSearchData(searchId) {
            let token = "Bearer " + localStorage.getItem("accessToken");
            this.isLoading = true;
            let response = await HTTP(
                "get",
                "v1/control-group/population/search/" + searchId,
                null, {
                    Authorization: token
                }
            );

            this.searchData = response.data;


            if (response.data) {
                let priData = JSON.parse(
                    response.data.control_group_search.control_group.client_pri_versions
                    .configuration
                );
                this.priSearchData = priData;

                this.isLoading = false;

                let JSonData = JSON.parse(response.data.data);

               
                this.negativeMediaArray = JSonData.negativeMedia;
                this.futureRisksArray = JSonData.futureRisks;

                // console.log("JSonData.futureRisks", JSonData.futureRisks);

                this.sanctions = JSonData.sanctions;
                // console.log("JSonData.sanctions", JSonData.sanctions);
                this.openCorporateData = JSonData.openCorporate;
               

                this.publicListedCompanies = JSonData.publicListedCompanies;

                /**
                 * Open Corporate
                 */
                //this.companyTotals = JSonData.openCorporateTotals;
            }
        }
    }
};
</script>

<style scoped>
span.sort-icon {
    float: right;
    color: #ff9100;
}
</style>
